module.exports = __webpack_public_path__ + "static/media/Logo.086beba6.png";